export const TPRM_EMPTY_VALUE = "—";

export const displayTPRMValue = (value) => {
  if (value === null || value === undefined || value === "") return TPRM_EMPTY_VALUE;
  if (typeof value === "object") return TPRM_EMPTY_VALUE;
  return String(value);
};

export const formatTPRMDate = (value) => {
  if (value === null || value === undefined || value === "") return TPRM_EMPTY_VALUE;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return TPRM_EMPTY_VALUE;
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    timeZone: "UTC",
  }).format(date);
};

export const formatTPRMTimestamp = (value) => {
  if (value === null || value === undefined || value === "") return TPRM_EMPTY_VALUE;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return TPRM_EMPTY_VALUE;
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
    timeZoneName: "short",
  }).format(date);
};

export const normalizeTPRMPage = (data, collectionKey = "results") => {
  if (Array.isArray(data)) return { results: data, count: data.length };
  const results = Array.isArray(data?.[collectionKey])
    ? data[collectionKey]
    : [];
  const rawCount = data?.count;
  const count =
    rawCount !== null &&
    rawCount !== undefined &&
    rawCount !== "" &&
    Number.isFinite(Number(rawCount))
      ? Number(rawCount)
      : results.length;
  return { results, count };
};

export const getTPRMErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  if (typeof data?.detail === "string") return data.detail;
  if (typeof data === "string") return data;
  if (data && typeof data === "object") {
    const messages = Object.values(data)
      .flatMap((value) => (Array.isArray(value) ? value : [value]))
      .filter((value) => typeof value === "string");
    if (messages.length) return messages.join(" ");
  }
  return error?.message || fallback;
};
